<div class="d-flex flex-column no-scroll-bar overflow-hidden h-100 w-100">
    @if (viewportService.isLargeViewPort()) {
        <div class="d-flex overflow-hidden h-100 position-relative">
            <div class="width-400px">
                <app-login/>
            </div>
        </div>
    } @else {
        <div class="overflow-hidden h-100 position-relative">
            <app-login/>
        </div>
    }
</div>
